module.exports = __webpack_public_path__ + "static/brotzeit-desktop-6873d841d52706b45e416e0ec7d43fc0.jpg";